module.exports = __webpack_public_path__ + "static/media/helix_map.7b418915.svg";